<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.amount = item.amount;
        itemDetails.rarity = `3`;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
        itemDetails.icon = `chat-bubble-winter`;

        switch (item.id) {
            case 623:
                itemDetails.title = $_(`StPatrickChatBubbleTitle`);
                itemDetails.description = $_(`StPatrickChatBubbleDescription`);
                break;
            case 2199:
                itemDetails.title = $_(`4thofjulyChatBubbleTitle`);
                itemDetails.description = $_(`4thofjulyChatBubbleDescription`);
                break;
            case 2241:
                itemDetails.title = $_(`WinterChatBubbleTitle`);
                itemDetails.description = $_(`WinterChatBubbleDescription`);
                break;
            case 2452:
                itemDetails.title = $_(`WorldCupChatBubbleTitle`);
                itemDetails.description = $_(`WorldCupChatBubbleDescription`);
                break;
            default:
                itemDetails.title = $_(`DefaultChatBubbleTitle`);
                itemDetails.description = $_(`DefaultChatBubbleDescription`);
                break;
        }
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
